export const VERSION = "2.3.4";

export const stringDateFormat = "yyyy-MM-dd";
